import * as Actions from 'reducks/auth/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const AuthReducer = (state = initialState.auth, action: any) => {
  switch (action.type) {
    case Actions.FETCH_EVENT_REFS:
      return {
        ...state,
        attending_event_refs: [...action.payload],
      }
    case Actions.FETCH_SWITCHING_STORE_REFS:
      return {
        ...state,
        switching_store_refs: [...action.payload],
      }
    case Actions.SELECT_TOP_TAB:
      return {
        ...state,
        top_tab: action.payload,
      }
    case Actions.SELECT_DEFAULT_BREAD_TYPES:
      return {
        ...state,
        default_bread_types: [...action.payload],
      }

    case Actions.SIGN_IN:
      return {
        ...action.payload,
      }
    case Actions.SIGN_OUT:
      return {
        ...initialState.auth,
      }
    case Actions.SWITCH_STORE:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.SWITCH_BACK_TO_ADMIN:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.TOGGLE_MAILS:
      return {
        ...state,
        mails: [...action.payload.mails],
      }
    case Actions.TOGGLE_PUSH_SETTINGS:
      return {
        ...state,
        push_settings: [...action.payload.push_settings],
      }
    case Actions.UPDATE_AUTH_BRAND_REF:
      return {
        ...state,
        brand_ref: action.payload.brand_ref,
      }
    default:
      return state
  }
}
